exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".subtitle {\n  display: flex;\n  flex-direction: column;\n  padding: 1px 8px 8px 8px;\n  font-size: 12px;\n}\n", ""]);

// exports
